import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ContractGetSummaryCollectionByLotId, ContractGetSummaryCollectionByLotIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ContractGetSummaryCollectionByLotIdResponse, ContractGetSummaryCollectionByLotIdResponse>) => {
    return response?.data?.contractSummaries
}
const getError = (response?: SWRResponse<ContractGetSummaryCollectionByLotIdResponse, ContractGetSummaryCollectionByLotIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useContractSummariesByLotId = (lotId: number, configuration?: SWRConfiguration<ContractGetSummaryCollectionByLotIdResponse, ContractGetSummaryCollectionByLotIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ContractGetSummaryCollectionByLotId({
                lotId: lotId
            });
        };
    }, [lotId])

    return useGet(request, { getData, getError }, configuration);
}

export default useContractSummariesByLotId;